"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _SVGIcon = _interopRequireDefault(require("@instructure/ui-svg-images/lib/components/SVGIcon"));
var _ref = /*#__PURE__*/
_react.default.createElement("path", {
  d: "M616.625 1262.663l85.636 85.636-352.354 352.233-85.636-85.636 352.354-352.233zM0 1526.947l440.533-440.533 85.514 85.757-440.411 440.29L0 1526.947zm528.494 176.056l264.296-264.296 85.635 85.757-264.295 264.174-85.636-85.635zm527.295-179.872l591.819-591.818-2.665 707.614-236.558 236.68h-.121l-352.475-352.476zM325.95 320.066l707.492-2.786-591.697 591.697L89.27 556.745l236.68-236.679zm1262.404 240.567l-42.757 42.878-184.11-184.231 42.756-42.879c86.605-86.483 172.24-102.108 226.747-100.291l55.96 2.059 2.301 56.08c2.302 54.992-13.323 138.932-100.897 226.384zm302.087-486.56c-73.281-27.617-341.21-101.382-615.56 172.967L570.174 951.747l221.417 221.538 221.418 221.417 704.707-704.828c273.016-273.017 199.857-543.005 172.725-615.801",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});
var IconQuiz = /*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(IconQuiz, _Component);
  function IconQuiz() {
    (0, _classCallCheck2.default)(this, IconQuiz);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IconQuiz).apply(this, arguments));
  }
  (0, _createClass2.default)(IconQuiz, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_SVGIcon.default, Object.assign({}, this.props, {
        name: "IconQuiz",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);
  IconQuiz.displayName = "IconQuiz";
  return IconQuiz;
}(_react.Component);
exports.default = IconQuiz;
IconQuiz.glyphName = 'quiz';
IconQuiz.variant = 'Solid';
IconQuiz.propTypes = (0, _objectSpread2.default)({}, _SVGIcon.default.propTypes);